<template>
  <div class="fireStation" :style="{ backgroundImage: `url(${mapUrl})` }">
    <header class="header">
      <div class="header-left">
        <!-- <img src="./img/logo.png" alt="logo" class="logo" /> -->
        <div class="title-container">
          <!-- <div class="title-divider"></div> -->
          <span class="title-main">智能移动巡检</span>
          <!-- <div class="lg-tag">LG</div> -->
        </div>
      </div>
      <div class="header-right">
        <button class="back-btn" @click="backHome">
          <span>返回</span>
        </button>
        <div class="time">{{ currentTime }}</div>
        <div class="time-display">
          <div class="week">{{ weekDay }}</div>
          <div class="date">{{ currentDate }}</div>
        </div>
      </div>
    </header>
    <!-- 导航标签 -->
    <div class="nav-tabs">
      <div class="tab" :class="{ active: tabValue === 0 }">
        日常巡视
      </div>
      <div class="tab" :class="{ active: tabValue === 1 }">联动出警</div>
    </div>

    <div class="operation-btn" @click="handleOneClick">自动巡视</div>

    <div class="canvas">
      <canvas ref="mapCanvas" class="map-canvas"></canvas>
    </div>

    <template v-if="points.length > 0 && !isShowClick">
      <template v-for="(point, index) in points">
        <img
          src="./img/robot.png"
          class="robot"
          :style="{
            left: (canvasWidth / areaPoint.width).toFixed(2) * point.latitude - 28 + 'px',
            top: (canvasHeight / areaPoint.height).toFixed(2) * point.longitude - 124 + 'px'
          }"
          v-if="point.posType == 0"
          :key="`robot-${index}`"
          :alt="point.posY"
        />
        <img
          src="./img/yizhan.png"
          class="yizhan"
          :style="{
            left: (canvasWidth / areaPoint.width).toFixed(2) * point.latitude - 16 + 'px',
            top: (canvasHeight / areaPoint.height).toFixed(2) * point.longitude - 16 + 'px'
          }"
          v-if="point.posType == 3"
          :key="`yizhan-${index}`"
          @contextmenu="handleContextMenu($event, point)"
        />
        <span
          class="yizhan-name"
          :style="{
            left: (canvasWidth / areaPoint.width).toFixed(2) * point.latitude + 16 + 'px',
            top: (canvasHeight / areaPoint.height).toFixed(2) * point.longitude - 8 + 'px'
          }"
          v-if="point.posType == 3"
          :key="`yizhan-name-${index}`"
          >{{ point.posName }}</span
        >
      </template>
    </template>

    <ul
      class="context-menu"
      v-if="isShowMenu"
      :style="{ left: contextMenuX + 'px', top: contextMenuY + 'px' }"
    >
      <li @click="changeContextMenu(0)">巡视</li>
      <li @click="changeContextMenu(1)">返回</li>
    </ul>

    <div class="points" v-if="isShowAlarm">
      <div
        class="point"
        :style="{
          left: (canvasWidth / areaPoint.width).toFixed(2) * alarmInfo.latitude - 30 + 'px',
          top: (canvasHeight / areaPoint.height).toFixed(2) * alarmInfo.longitude - 30 + 'px'
        }"
      >
        <div class="point-info">
          <div class="point-title"></div>
          <button class="point-btn" @click="toSilence">消音</button>
          <button class="point-btn back-btn" :disabled="isExcuteTask" @click="goBack">返回</button>
          <div class="point-content">
            {{ alarmInfo.mapMsg }}
          </div>
        </div>
      </div>
    </div>

    <div class="right-panel">
      <div class="panel-section video-monitor">
        <div class="section-header">
          <span>视频监控</span>
        </div>
        <div class="video-container">
          <div class="video-item" v-if="videoUrl">
            <videoPlayer :videoUrl="videoUrl" :id="deviceId" @openVideo="_openVideo"></videoPlayer>
          </div>
          <div v-else class="video-item noVideo">暂无视频</div>
          <div class="video-info">视频设备名称：{{ videoName }}</div>
        </div>
      </div>
      <div class="panel-section">
        <div class="section-header">
          <span>信息窗口</span>
        </div>
        <div class="port-list" v-if="infoPorts.length > 0">
          <div
            v-for="(port, index) in infoPorts"
            :key="index"
            class="port-item"
            :class="{ 'active-port': index === 0 }"
          >
            {{ port }}
          </div>
        </div>
      </div>
    </div>
    <footer class="footer"></footer>
    <play-video v-if="isOpen" :videoUrl="videoUrls" @closeVideo="closeVideo"></play-video>
    <div style="display: none;">
      <img ref="pointImage" src="./img/point.png" @load="imageLoaded('point')" />
      <img ref="carImage" src="./img/robot.png" @load="imageLoaded('car')" />
      <img ref="endImage" src="./img/yizhan.png" @load="imageLoaded('end')" />
    </div>
  </div>
</template>

<script>
  import { date } from 'utils'
  import WebSocketService from './socket'
  export default {
    data() {
      return {
        currentTime: '',
        currentDate: '',
        weekDay: '',
        timer: null,
        tabValue: 0,
        infoPorts: [],
        ctx: null,
        canvasWidth: 0,
        canvasHeight: 0,
        points: [],
        isShowMenu: false,
        contextMenuX: 0,
        contextMenuY: 0,
        deviceId: '',
        isOpen: false,
        videoUrl: '',
        videoUrls: '',
        videoName: '',
        videoTimer: null,
        isFullScreen: false,
        taskId: 0, // 任务id
        backTaskId: 0, // 返回任务id
        currentTaskId: 0, // 当前任务id
        websocket: null,
        isExcuteTask: false,
        alarmSocket: null,
        alarmInfo: {},
        isShowAlarm: false,
        // 图片资源
        images: {
          point: null,
          car: null,
          end: null
        },
        // 图片加载状态
        imagesLoaded: {
          point: false,
          car: false,
          end: false
        },
        predefinedPoints: [],
        originPoints: [],
        isShowClick: false,
        isClickBack: false, // 是否点击返回
        synth: null,
        speaker: null,
        audio: null,
        areaPoint: {
          width: 0,
          height: 0
        },
        // 添加动画控制
        animation: {
          lastTime: 0,
          throttleInterval: 16 // 约60fps
        },
        latestPoint: {
          posX: 0,
          posY: 0
        },
        mapUrl: '',
        videoInfo: {}, // 是否显示视频
        currentId: null, // 当前点位id
        isGoCheck: false,
        currentPointIndex: 0, // 当前点位索引
        targetPointIndex: null, // 目标点位索引
        waitingForMatch: true, // 是否等待点位名称匹配
        // 移动对象属性
        movingObject: {
          pointX: 0, // 当前X坐标
          pointY: 0, // 当前Y坐标
          speed: 0.2 // 移动速度
        },
        // 动画控制
        isMoving: false, // 是否正在移动
        animationId: null, // 动画帧ID
        processedAreaIds: new Set(), // 已处理区域ID集合
        mapDeviceId: null, // 地图设备id
        hasCount: 0,
        hasReceivedOtherPoints: false,
        isAccelerating: false, // 是否处于加速状态
        acceleratedSpeed: 9, // 加速后的速度
        pendingAreaIds: [], // 存储待处理的区域ID
        dealTaskId: [29, 30, 31], // 处理任务id
        currentTaskIndex: 0, // 当前执行的任务索引
        isAutoExecuting: false, // 是否在自动执行模式
        isClickOne: false, // 是否点击一键巡视
        isHandlingEndpoint: false, // 是否正在处理终点
        timerIds: {
          nextTask: null,
          init: null
        }
      }
    },
    components: {
      videoPlayer: () => import('./components/video'),
      playVideo: () => import('./components/playVideo')
    },
    computed: {
      // 检查所有图片是否已加载
      allImagesLoaded() {
        return Object.values(this.imagesLoaded).every(loaded => loaded)
      }
    },
    created() {
      // 监听全屏变化
      this.setupFullscreenListeners()
    },
    mounted() {
      this.audio = new Audio('/static/minorAlarm.mp3?rd=' + new Date().getTime())
      this.initDateTime()
      this.enterfullscreen()
      this.initImages()
      this.timerIds.init = setTimeout(() => {
        this.timerIds.init = null
        this.initCanvas()
        this.initList()
        this.initAlarmInfo()
        this.initCameraList()
        this.refreshVideo()
      }, 200)

      this.initPositionWebSocket()
      // 添加全局点击事件监听
      document.addEventListener('click', this.handleGlobalClick)
    },
    methods: {
      refreshVideo() {
        if (this.videoTimer) {
          this.videoTimer = null
        }
        this.videoTimer = setInterval(() => {
          this.videoUrl = ''
          this.$axiospost('operation/robotMapDevice/queryList').then(res => {
            let item = res.data.data.find(item => item.mapType === 1)
            this.videoUrl = item.mapDeviceImgUrl
            this.deviceId = item.mapBindDeviceId
          })
        }, 60000)
      },
      // 获取视频列表
      initCameraList() {
        this.$axiospost('operation/robotMapDevice/queryList').then(res => {
          let item = res.data.data.find(item => item.mapType === 1)
          this.videoUrl = item.mapDeviceImgUrl
          this.deviceId = item.mapBindDeviceId
          this.videoName = item.mapDeviceName
        })
      },
      // 初始化日期时间
      initDateTime() {
        let dates = date(new Date())
        this.currentDate = [dates.YY, dates.MM, dates.DD].join('.')
        let times = date(new Date())
        this.currentTime = [times.hh, times.mm, times.ss].join(':')
        this.timer = setInterval(() => {
          let times = date(new Date())
          this.currentTime = [times.hh, times.mm, times.ss].join(':')
        }, 1000)
        this.weekDay = '星期' + '日一二三四五六'.charAt(new Date().getDay())
      },
      // 设置全屏监听器
      setupFullscreenListeners() {
        let isFullScreen =
          document.fullscreenElement ||
          document.mozFullScreenElement ||
          document.webkitFullscreenElement ||
          document.fullScreen ||
          document.mozFullScreen ||
          document.webkitIsFullScreen
        isFullScreen = !!isFullScreen

        const fullscreenChangeHandler = () => {
          this.isFullScreen = !isFullScreen
        }

        document.addEventListener('fullscreenchange', fullscreenChangeHandler)
        document.addEventListener('mozfullscreenchange', fullscreenChangeHandler)
        document.addEventListener('webkitfullscreenchange', fullscreenChangeHandler)
        document.addEventListener('msfullscreenchange', fullscreenChangeHandler)
      },

      //进入全屏
      enterfullscreen() {
        let docElm = document.documentElement
        if (!this.isFullScreen) {
          if (docElm.requestFullscreen) {
            docElm.requestFullscreen()
          } else if (docElm.mozRequestFullScreen) {
            docElm.mozRequestFullScreen()
          } else if (docElm.webkitRequestFullScreen) {
            docElm.webkitRequestFullScreen()
          } else if (elem.msRequestFullscreen) {
            elem.msRequestFullscreen()
          }
        }
      },

      // 返回首页
      backHome() {
        this.exitFullscreen()
        this.$router.push({ name: 'home' })
      },

      // 退出全屏
      exitFullscreen() {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
      },

      // 初始化位置和获取地图大小
      initList() {
        this.isHandlingEndpoint = false
        this.$axiospost('operation/robotMap/getAll').then(res => {
          this.areaPoint.width = res.data.data[0].mapWidth
          this.areaPoint.height = res.data.data[0].mapHeight
          this.mapUrl = res.data.data[0].mapUrl
          let fileUrl = process.env.fileUrl
          if (this.mapUrl && this.mapUrl.includes(fileUrl)) {
            if (process.env.SSL_ENABLE || process.env.SSL_ENABLE === 'true') {
              this.mapUrl = this.mapUrl.replaceAll(fileUrl, process.env.SSL_HOST + '/file')
            }
          }
        })

        this.$axiospost('operation/robotPos/queryList').then(res => {
          this.points =
            res.data.data.length > 0
              ? res.data.data
                  .filter(item => item.posType != 1)
                  .map(item => {
                    return {
                      ...item,
                      posX:
                        item.posType == 0 && this.latestPoint.posX != 0
                          ? this.latestPoint.posX
                          : item.posX,
                      posY:
                        item.posType == 0 && this.latestPoint.posY != 0
                          ? this.latestPoint.posY
                          : item.posY
                    }
                  })
              : []
          console.log(this.points)
        })
      },

      // 视频相关方法
      _openVideo() {
        this.videoUrls = this.videoUrl
        this.isOpen = true
      },
      closeVideo() {
        this.isOpen = false
        this.videoUrls = ''
      },
      // 获取WebSocket URL
      getWebSocketUrl(path) {
        const a = localStorage.getItem('userphone')
        const b = localStorage.getItem('companyId')
        let wsUrl = ''
        if (process.env.NODE_ENV === 'development') {
          wsUrl =
            process.env.SSL_HOST.indexOf('https') != -1
              ? `wss://${process.env.SSL_HOST.replace(
                  /^https?\:\/\//i,
                  ''
                )}/api/socket/${path}/${a}/${b}`
              : `ws://${process.env.SSL_HOST.replace(
                  /^https?\:\/\//i,
                  ''
                )}/api/socket/${path}/${a}/${b}`
        } else {
          wsUrl =
            process.env.SSL_ENABLE || process.env.SSL_ENABLE === 'true'
              ? `wss://${window.location.host}${process.env.API_HOST}socket/${path}/${a}/${b}`
              : `ws://${window.location.host}${process.env.API_HOST}socket/${path}/${a}/${b}`
        }
        return wsUrl
      },
      // 初始化报警WebSocket
      initAlarmInfo() {
        const wsUrl = this.getWebSocketUrl('robot/alarm')
        this.alarmSocket = new WebSocketService(wsUrl)
        // 添加事件监听
        this.alarmSocket.onMessage(this.handleAlarmSocketMessage)
        this.alarmSocket.onOpen(() => console.log('报警WebSocket连接已建立'))
        this.alarmSocket.onClose(() => console.log('报警WebSocket连接已关闭'))

        // 连接WebSocket
        this.alarmSocket.connect()
      },

      // 初始化位置WebSocket
      initPositionWebSocket() {
        if (this.websocket) {
          // 如果已经存在连接，直接返回
          return this.websocket
        }

        const wsUrl = this.getWebSocketUrl('robot/position')
        this.websocket = new WebSocketService(wsUrl)

        // 添加事件监听
        this.websocket.onMessage(this.handleWebSocketMessage)
        this.websocket.onOpen(() => console.log('位置WebSocket连接已建立'))
        this.websocket.onClose(event => {
          console.log('位置WebSocket连接已关闭')
        })

        // 连接WebSocket
        this.websocket.connect()

        return this.websocket
      },
      // 获取任务路径点
      getTaskPoints(value) {
        this.predefinedPoints = value === 0 ? this.originPoints : this.originPoints.reverse()
        this.movingObject.pointX = parseInt(this.predefinedPoints[0].latitude)
        this.movingObject.pointY = parseInt(this.predefinedPoints[0].longitude)
        this.currentPointIndex = 0
        this.waitingForMatch = true
        this.drawScene()
        return Promise.resolve()
      },

      // 执行任务
      executeTask(taskId) {
        return this.$axiosget(`operation/robotTask/executeTaskByTaskId/${taskId}`).then(res => {
          if (res.data.status === '10000') {
            this.isShowMenu = false
            this.$message.success(res.data.data || '下发成功')
            this.isExcuteTask = true
            this.isShowClick = true
            this.hasCount = 0
            // 初始化WebSocket
            this.initPositionWebSocket()
            // 第一个点位直接开始移动
            this.waitingForMatch = false
            this.moveToNextPoint()
          }
          return res
        })
        // return new Promise(resolve => {
        //   // 模拟网络延迟
        //   setTimeout(() => {
        //     this.isShowMenu = false
        //     this.$message.success('任务下发成功')
        //     this.isExcuteTask = true
        //     this.isShowClick = true
        //     this.hasCount = 0
        //     this.waitingForMatch = false
        //     this.moveToNextPoint()

        //     // 立即开始模拟推送消息
        //     this.mockReceiveTaskMessages(taskId)

        //     resolve({ data: { status: '10000', data: '下发成功' } })
        //   }, 1000)
        // })
      },
      // 模拟任务点位数据
      mockTaskPoints() {
        const taskData = {
          33: [
            {
              areaId: 112,
              latitude: '679',
              longitude: '261',
              name: '1'
            },
            {
              areaId: 113,
              latitude: '679',
              longitude: '261',
              name: '2'
            },
            {
              areaId: 114,
              latitude: '659',
              longitude: '380',
              name: '3'
            },
            {
              areaId: 115,
              latitude: '392',
              longitude: '327',
              name: '4'
            }
          ]
        }

        return taskData
      },
      mockReceiveTaskMessages() {
        const taskPoints = this.mockTaskPoints()[this.currentTaskId] || []

        // 清除之前的定时器
        if (this.mockInterval) {
          clearTimeout(this.mockInterval)
        }

        let messageIndex = 0

        // 模拟发送第一条消息
        const sendNextMessage = () => {
          if (messageIndex < taskPoints.length) {
            const point = taskPoints[messageIndex]

            // 构造模拟消息
            const message = {
              eventMsg: [
                {
                  eventMsg: `到达点位 ${point.name}`,
                  taskId: this.currentTaskId,
                  areaId: point.areaId
                }
              ]
            }

            console.log('模拟接收WebSocket消息:', message)

            // 处理模拟消息
            this.handleWebSocketMessage(message)

            messageIndex++

            // 设置下一条消息的延迟时间 - 为了模拟真实情况，使用不同的延迟时间
            const delays = [0, 10000, 30000, 40000]
            const delay = delays[messageIndex % delays.length] || 5000

            // 设置下一次推送
            if (messageIndex < taskPoints.length) {
              this.mockInterval = setTimeout(sendNextMessage, delay)
            }
          }
        }
        sendNextMessage()
        // this.mockInterval = setTimeout(sendNextMessage, 10000)
      },
      // 处理全局点击事件
      handleGlobalClick(event) {
        // 如果点击的不是右键菜单内的元素，则关闭菜单
        if (!event.target.closest('.context-menu')) {
          this.isShowMenu = false
        }
      },
      // 处理右键菜单
      handleContextMenu(event, item) {
        event.preventDefault()
        event.stopPropagation() // 阻止事件冒泡
        if (this.isExcuteTask) return
        this.isShowMenu = true
        this.contextMenuX = event.clientX
        this.contextMenuY = event.clientY
        this.currentId = item.id
        this.taskId = item.posTask
        this.backTaskId = item.posTaskBack
        this.originPoints = item.subRoutePoints.map(point => {
          return {
            ...point,
            pointX: parseInt(point.latitude),
            pointY: parseInt(point.longitude)
          }
        })
      },
      // 菜单操作
      changeContextMenu(val) {
        const currentTaskId = val === 0 ? this.taskId : this.backTaskId
        this.currentTaskId = currentTaskId

        this.isGoCheck = val === 0 ? true : false
        // 如果是返回操作，先清除现有WebSocket
        if (val === 1) {
          this.websocket = null
          this.currentPointIndex = 0
          this.targetPointIndex = null
          this.waitingForMatch = true
        }
        // 执行任务流程
        this.getTaskPoints(val)
          .then(() => this.executeTask(currentTaskId))
          .catch(err => console.error('执行任务失败:', err))
      },
      // 一键巡视
      handleOneClick() {
        if (this.isExcuteTask) {
          this.$message.warning('当前有任务正在执行，请等待任务完成')
          return
        }
        if (this.isClickOne) return
        this.isClickOne = true
        this.isAutoExecuting = true
        this.currentTaskIndex = 0
        this.processedAreaIds.clear()
        this.pendingAreaIds = []
        // 开始执行第一个任务
        this.executeNextTask()
      },
      // 执行下一个任务
      executeNextTask() {
        if (!this.isAutoExecuting || this.currentTaskIndex >= this.dealTaskId.length) {
          this.isAutoExecuting = false
          this.isClickOne = false
          return
        }
        // 获取当前要执行的任务ID
        const taskId = this.dealTaskId[this.currentTaskIndex]
        this.currentTaskId = taskId

        this.currentId = this.points.find(item => item.posTask === taskId)
          ? this.points.find(item => item.posTask === taskId).id
          : ''

        this.originPoints = this.points
          .filter(item => item.posTask === taskId)[0]
          .subRoutePoints.map(point => {
            return {
              ...point,
              pointX: parseInt(point.latitude),
              pointY: parseInt(point.longitude)
            }
          })

        // 准备并执行任务
        this.isGoCheck = true
        this.getTaskPoints(0)
          .then(() => this.executeTask(taskId))
          .catch(err => console.error('执行任务失败:', err))
      },
      // 处理WebSocket位置消息
      handleWebSocketMessage(data) {
        try {
          if (data.alarmMsg) {
            this.handleAlarmMessage(data.alarmMsg)
          }
          // 处理消息记录
          if (data.eventMsg && data.eventMsg.length > 0) {
            this.handleEventMessages(data.eventMsg)
          }

          if (data.eventMsg && data.eventMsg.length > 0 && this.infoPorts.length > 0) {
            const currentPoint = this.predefinedPoints[this.currentPointIndex]

            // 获取当前推送的 areaId
            const foundItem =
              data.eventMsg && data.eventMsg.find(item => item.taskId === this.currentTaskId)
            const currentAreaId =
              (foundItem && foundItem.hasOwnProperty('areaId') && foundItem.areaId) || ''

            // 如果当前有动画在进行，并且收到了下一个点位的消息，则触发加速
            if (
              this.isMoving &&
              !this.processedAreaIds.has(currentAreaId) &&
              currentAreaId != currentPoint.areaId
            ) {
              this.isAccelerating = true // 设置加速标志
              console.log('收到新点位推送，加速移动')
            }

            // 检查是否是第一次收到这个 areaId
            if (!this.processedAreaIds.has(currentAreaId) && currentAreaId == currentPoint.areaId) {
              // 第一次收到该 areaId
              this.processedAreaIds.add(currentAreaId)
              // 第一个点位已经移动过了，后续点位需要等待匹配
              if (this.currentPointIndex > 0) {
                this.moveToNextPoint()
              }
              this.hasReceivedOtherPoints = true // 设置标志位
            }

            // 记录尚未处理的点位
            if (
              currentAreaId &&
              !this.processedAreaIds.has(currentAreaId) &&
              currentAreaId != currentPoint.areaId
            ) {
              if (!this.pendingAreaIds.includes(currentAreaId)) {
                this.pendingAreaIds.push(currentAreaId)
                console.log('添加待处理点位:', currentAreaId)
              }
            }

            if (
              this.hasReceivedOtherPoints &&
              this.processedAreaIds.has(currentAreaId) &&
              currentAreaId === this.predefinedPoints[this.predefinedPoints.length - 1].areaId &&
              this.hasCount === 0 &&
              !this.pendingAreaIds.length
            ) {
              console.log('socket到达终点')
              this.latestPoint.posX = this.predefinedPoints[this.predefinedPoints.length - 1].pointX
              this.latestPoint.posY = this.predefinedPoints[this.predefinedPoints.length - 1].pointY
              this.handleEndpointReached()
              this.hasCount = 1
            }
          }
        } catch (error) {
          console.error('处理WebSocket消息时出错:', error)
        }
      },

      // 处理事件消息
      handleEventMessages(messages) {
        if (!Array.isArray(messages) || messages.length === 0) return

        const currentDate = date(new Date())
        const formattedDate = `${currentDate.YY}-${currentDate.MM}-${currentDate.DD}`
        const formattedTime = `${currentDate.hh}:${currentDate.mm}:${currentDate.ss}`
        const timestamp = `${formattedDate} ${formattedTime}`

        // 批量处理消息
        const newMessages = messages
          .filter(item => item.taskId === this.currentTaskId)
          .filter(item => !this.isDuplicateMessage(item.eventMsg))
          .map(item => `${timestamp} ${item.eventMsg}`)

        // 如果有新消息，一次性更新数组
        if (newMessages.length > 0) {
          this.infoPorts.unshift(...newMessages)
        }
      },

      // 处理报警消息
      handleAlarmMessage(alarmMsg) {
        const currentDate = date(new Date())
        const formattedDate = `${currentDate.YY}-${currentDate.MM}-${currentDate.DD}`
        const formattedTime = `${currentDate.hh}:${currentDate.mm}:${currentDate.ss}`
        const timestamp = `${formattedDate} ${formattedTime}`

        if (!this.isDuplicateMessage(alarmMsg)) {
          this.infoPorts.unshift(`${timestamp} ${alarmMsg}`)
        }
      },

      // 检查消息是否重复
      isDuplicateMessage(message) {
        if (this.infoPorts.length === 0) return false

        // 只检查最新的一条消息
        const lastMessage = this.infoPorts[0] // 因为新消息是通过 unshift 添加到数组开头的
        return lastMessage.includes(message)
      },

      // 处理报警消息
      handleAlarmSocketMessage(data) {
        // 重置状态
        this.resetAlarmState()
        // 设置报警信息
        this.alarmInfo = data
        this.currentTaskId = this.alarmInfo.posCommand

        this.mapDeviceId = data.id

        this.originPoints = data.subRoutePoints.map(point => {
          return {
            ...point,
            pointX: parseInt(point.latitude),
            pointY: parseInt(point.longitude)
          }
        })

        // 播放提示音及语音播报
        new Promise((resolve, reject) => {
          try {
            this.audio.load()
            this.audio.addEventListener('canplaythrough', ev => {
              try {
                console.log(this.audio, '播放正常')
                this.audio.play()
              } catch (e) {
                console.log('语音播放失败', e)
                //TODO handle the exception
              }
            })
          } catch (e) {
            console.error('告警提示音播放失败！', e)
          }
          resolve()
        }).then(() => {
          this.synth = this.synth || window.speechSynthesis
          this.speaker = this.speaker || new SpeechSynthesisUtterance()
          this.speaker.lang = 'zh-CN'
          this.speaker.text = this.alarmInfo.mapMsg
          setTimeout(() => {
            try {
              this.audio.pause()
              this.synth.cancel()
              let count = 0
              while (this.synth && count < 99) {
                this.synth.speak(this.speaker)
                // 无需删除，控制执行流程
                count++
              }
            } catch (e) {
              console.error('语音播报告警失败！', e)
            }
          }, 3000)
        })

        // 执行报警任务
        this.handleAlarmTask()
      },

      // 重置报警状态
      resetAlarmState() {
        this.currentPointIndex = 0
        this.targetPointIndex = null
        this.waitingForMatch = true
        this.isClickBack = false
        this.tabValue = 1
        this.isShowAlarm = true
        this.websocket = null
        this.isShowMenu = false
        this.isExcuteTask = true
        this.isShowClick = true
        this.isGoCheck = true
        // 停止音频
        this.stopAudio()
      },
      // 停止音频
      stopAudio() {
        try {
          this.audio.pause()
          if (this.synth) this.synth.pause()
        } catch (e) {
          // 忽略错误
        }
        this.synth = null
        this.speaker = null
      },

      // 处理报警任务
      handleAlarmTask() {
        this.getTaskPoints(0)
          .then(() => this.executeTask(this.alarmInfo.posCommand))
          .catch(err => console.error('执行报警任务失败:', err))
      },

      // 消音
      toSilence() {
        this.stopAudio()
      },

      // 返回
      goBack() {
        this.currentPointIndex = 0
        this.targetPointIndex = null
        this.waitingForMatch = true
        if (this.isExcuteTask) return

        this.isGoCheck = false
        this.isClickBack = true
        this.currentTaskId = this.alarmInfo.posCommandBack

        this.getTaskPoints(1)
          .then(() => this.executeTask(this.alarmInfo.posCommandBack))
          .catch(err => console.error('执行返回任务失败:', err))
      },

      // 初始化图片
      initImages() {
        this.$nextTick(() => {
          if (this.$refs.pointImage) {
            this.images.point = this.$refs.pointImage
            this.imagesLoaded.point = true
          }

          if (this.$refs.carImage) {
            this.images.car = this.$refs.carImage
            this.imagesLoaded.car = true
          }

          if (this.$refs.endImage) {
            this.images.end = this.$refs.endImage
            this.imagesLoaded.end = true
          }

          this.checkImagesAndStart()
        })
      },

      // 图片加载完成
      imageLoaded(imageName) {
        this.imagesLoaded[imageName] = true
        this.checkImagesAndStart()
      },

      // 检查图片加载并初始化
      checkImagesAndStart() {
        if (this.allImagesLoaded) {
          // 可以在这里启动动画
          // this.startAnimation()
        }
      },

      // 初始化Canvas
      initCanvas() {
        const canvas = this.$refs.mapCanvas
        const container = canvas.parentElement

        this.canvasWidth = container.clientWidth
        this.canvasHeight = container.clientHeight

        // 设置Canvas的实际尺寸
        canvas.width = this.canvasWidth
        canvas.height = this.canvasHeight

        this.ctx = canvas.getContext('2d')
      },

      // 转换坐标
      transformCoords(x, y, flipY = true) {
        const scaleX = this.canvasWidth / this.areaPoint.width
        const scaleY = this.canvasHeight / this.areaPoint.height

        return {
          x: scaleX * x,
          y: flipY ? scaleY * y : scaleY * y
        }
      },

      // 绘制整个场景
      drawScene() {
        this.ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight)

        if (!this.predefinedPoints || this.predefinedPoints.length === 0) return

        // 绘制预定义路径
        this.drawPredefinedPath()

        // 绘制点位
        this.drawPoints()

        // 绘制移动对象
        this.drawMovingObject()
      },

      // 绘制路径
      drawPredefinedPath() {
        if (!this.predefinedPoints || this.predefinedPoints.length < 2) return

        try {
          this.ctx.beginPath()

          // 起点坐标
          const startCoords = this.transformCoords(
            this.predefinedPoints[0].pointX,
            this.predefinedPoints[0].pointY
          )
          this.ctx.moveTo(startCoords.x, startCoords.y + 16) // +16是路径偏移

          // 连接各点
          for (let i = 1; i < this.predefinedPoints.length; i++) {
            const coords = this.transformCoords(
              this.predefinedPoints[i].pointX,
              this.predefinedPoints[i].pointY
            )
            this.ctx.lineTo(coords.x, coords.y + 16)
          }

          // 设置样式
          this.ctx.strokeStyle = '#23f9e4'
          this.ctx.lineWidth = 2
          this.ctx.setLineDash([8, 4])
          this.ctx.stroke()
          this.ctx.setLineDash([])
        } catch (error) {
          console.error('绘制路径出错:', error)
        }
      },

      // 绘制点位
      drawPoints() {
        if (!this.images.point || !this.imagesLoaded.point) return
        if (!this.images.end || !this.imagesLoaded.end) return
        if (!this.predefinedPoints || this.predefinedPoints.length === 0) return

        try {
          const pointSize = 32
          const halfSize = pointSize / 2

          this.predefinedPoints.forEach(point => {
            const coords = this.transformCoords(point.pointX, point.pointY)

            // 绘制点位图片
            this.ctx.drawImage(
              this.images.point,
              coords.x - halfSize,
              coords.y - halfSize,
              pointSize,
              pointSize
            )

            this.ctx.font = '12px MicrosoftYaHei'
            this.ctx.fillStyle = '#fff'
            this.ctx.textAlign = 'center'
            this.ctx.textBaseline = 'middle'
            this.ctx.fillText(point.name, coords.x, coords.y - 30)
          })
        } catch (error) {
          console.error('绘制点位出错:', error)
        }
      },

      // 绘制移动对象
      drawMovingObject() {
        if (!this.images.car || !this.imagesLoaded.car) return
        if (!this.movingObject.pointX || !this.movingObject.pointY) return

        try {
          const coords = this.transformCoords(this.movingObject.pointX, this.movingObject.pointY)

          // 绘制移动对象图片
          this.ctx.drawImage(
            this.images.car,
            coords.x - 28, // 宽度偏移
            coords.y - 124, // 高度偏移
            59, // 宽度
            124 // 高度
          )
        } catch (error) {
          console.error('绘制移动对象出错:', error)
        }
      },

      moveToNextPoint() {
        const nextIndex = this.currentPointIndex + 1
        if (nextIndex < this.predefinedPoints.length) {
          const nextPoint = this.predefinedPoints[nextIndex]

          console.log(`移动到下一个点位: ${nextPoint.name}`)

          this.targetPointIndex = nextIndex

          this.startMovement()
          console.log(this.movingObject)
        }
      },
      startMovement() {
        // 先停止现有的动画
        if (this.animationId) {
          cancelAnimationFrame(this.animationId)
          this.animationId = null
        }

        if (this.isMoving) return

        this.isMoving = true
        this.waitingForMatch = false

        // 开始动画
        this.animateMovement()
      },
      animateMovement() {
        if (!this.isMoving) return

        // 获取目标点位
        const targetPoint = this.predefinedPoints[this.targetPointIndex]

        if (!targetPoint) {
          this.isMoving = false
          return
        }

        // 计算目标坐标
        const targetX = parseInt(targetPoint.latitude)
        const targetY = parseInt(targetPoint.longitude)

        // 计算方向和距离
        const dx = targetX - this.movingObject.pointX
        const dy = targetY - this.movingObject.pointY
        const distance = Math.sqrt(dx * dx + dy * dy)

        // 根据加速标志使用不同的速度
        const currentSpeed = this.isAccelerating ? this.acceleratedSpeed : this.movingObject.speed

        // 检查是否到达目标点
        if (distance < currentSpeed) {
          // 到达目标点
          this.movingObject.pointX = targetX
          this.movingObject.pointY = targetY

          // 更新当前点位
          this.currentPointIndex = this.targetPointIndex
          this.targetPointIndex = null

          // 停止移动
          this.isMoving = false
          this.isAccelerating = false
          this.waitingForMatch = true

          // 更新机器人位置
          this.drawScene()

          // 检查是否到达最后一个点位
          if (this.currentPointIndex === this.predefinedPoints.length - 1) {
            console.log('到达最后一个点位，结束任务')
            this.latestPoint.posX = this.predefinedPoints[this.predefinedPoints.length - 1].pointX
            this.latestPoint.posY = this.predefinedPoints[this.predefinedPoints.length - 1].pointY
            this.handleEndpointReached()
            return
          }

          // 检查是否下一个点位已经收到推送
          this.checkNextPoint()
        } else {
          // 计算移动步长
          const step = Math.min(currentSpeed, distance)
          const ratio = (step / distance) * 0.2

          // 更新位置
          this.movingObject.pointX += dx * ratio
          this.movingObject.pointY += dy * ratio

          this.drawScene()

          // 继续动画
          this.animationId = requestAnimationFrame(this.animateMovement.bind(this))
        }
      },
      // 检查下一个点位
      checkNextPoint() {
        // 计算下一个点位的索引
        const nextIndex = this.currentPointIndex + 1

        // 检查是否到达终点
        if (nextIndex >= this.predefinedPoints.length) {
          console.log('已到达终点')
          return
        }

        const nextPoint = this.predefinedPoints[nextIndex]

        console.log(this.pendingAreaIds.includes(nextPoint.areaId))
        // 检查下一个点位是否已经在待处理队列中
        if (this.pendingAreaIds.includes(nextPoint.areaId)) {
          // 从待处理队列中移除
          const index = this.pendingAreaIds.indexOf(nextPoint.areaId)
          if (index > -1) {
            this.pendingAreaIds.splice(index, 1)
          }

          // 标记为已处理
          this.processedAreaIds.add(nextPoint.areaId)

          // 移动到下一个点位
          console.log(`下一个点位 ${nextPoint.name} 已在推送队列中，继续移动`)
          this.isAccelerating = true
          this.moveToNextPoint()
        } else {
          this.isAccelerating = false
          this.moveToNextPoint()
        }
      },
      handleTaskPhoto() {
        this.$axiospost('operation/robotPos/saveCameraPicture', {
          robotPosId: this.currentId
        }).then(res => {
          console.log('拍照成功', res)
        })
      },
      handleAlarmPhoto() {
        this.$axiospost('operation/robotPos/saveCameraPicture', {
          mapDeviceId: this.mapDeviceId
        }).then(res => {
          console.log('拍照成功', res)
        })
      },
      // 处理到达终点
      handleEndpointReached() {
        // if (!this.isShowAlarm) {
        //   if (this.currentId !== null && this.isGoCheck) {
        //     this.handleTaskPhoto()
        //   }
        // } else {
        //   if (this.mapDeviceId !== null && this.isGoCheck) {
        //     this.handleAlarmPhoto()
        //   }
        // }

        if (this.isHandlingEndpoint) return
        this.isHandlingEndpoint = true

        if (this.animationId) {
          cancelAnimationFrame(this.animationId)
          this.animationId = null
        }

        this.isExcuteTask = false
        this.isAccelerating = false
        this.processedAreaIds.clear()
        this.currentPointIndex = 0
        this.targetPointIndex = null
        this.hasReceivedOtherPoints = false
        this.pendingAreaIds = []
        this.isMoving = false
        this.waitingForMatch = true
        this.isGoCheck = false

        // 根据不同场景处理
        if (this.isClickBack || !this.isShowAlarm) {
          this.isShowAlarm = false
          this.tabValue = 0
          this.isShowClick = false
          this.initList()
        }

        // 清除画布
        this.ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight)

        // 新增：自动执行下一个任务
        if (this.isAutoExecuting) {
          // 清除可能存在的定时器
          if (this.timerIds.nextTask) {
            clearTimeout(this.timerIds.nextTask)
            this.timerIds.nextTask = null
          }

          this.currentId = null
          this.currentTaskIndex++ // 进入下一个任务

          // 添加延迟，让系统有时间恢复状态
          this.timerIds.nextTask = setTimeout(() => {
            this.timerIds.nextTask = null
            this.executeNextTask()
          }, 30000)
        }
      }
    },
    // 组件销毁
    beforeDestroy() {
      // 清理定时器
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }

      if (this.videoTimer) {
        clearInterval(this.videoTimer)
        this.videoTimer = null
      }

      // 清理动画
      if (this.animationId) {
        cancelAnimationFrame(this.animationId)
        this.animationId = null
      }

      // 遍历并清理所有定时器
      Object.keys(this.timerIds).forEach(key => {
        if (this.timerIds[key]) {
          clearTimeout(this.timerIds[key])
          this.timerIds[key] = null
        }
      })

      // 关闭WebSocket
      if (this.websocket) {
        this.websocket.disconnect()
        this.websocket = null
      }

      if (this.alarmSocket) {
        this.alarmSocket.disconnect()
        this.alarmSocket = null
      }

      // 移除全局点击事件监听
      document.removeEventListener('click', this.handleGlobalClick)
    }
  }
</script>

<style lang="less">
  html::-webkit-scrollbar {
    width: 0;
  }
</style>

<style lang="less" scoped>
  .fireStation {
    height: 100%;
    background: url('./img/bg.png');
    background-size: 100% 100%;
    background-color: transparent;
    position: relative;

    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0.28rem 0.3rem;
      z-index: 20;

      &-left {
        display: flex;
        align-items: center;

        .logo {
          width: auto;
          height: 0.7rem;
        }

        .title-container {
          display: flex;
          align-items: center;

          .title-divider {
            width: 0.02rem;
            height: 0.17rem;
            background-color: #31d1ce;
            border-radius: 0.01rem;
            margin: 0 0.2rem 0 0.12rem;
          }

          .title-main {
            font-family: SimHei;
            font-size: 0.3rem;
            font-weight: bold;
            letter-spacing: 0.01rem;
            color: #fff;
          }

          .lg-tag {
            width: 0.65rem;
            height: 0.24rem;
            text-align: center;
            line-height: 0.24rem;
            background-color: #129bb1;
            border-radius: 0.12rem;
            margin-left: 0.18rem;
            font-family: MicrosoftYaHei;
            font-size: 0.16rem;
            font-weight: bold;
            color: #fff;
          }
        }
      }

      &-right {
        display: flex;
        align-items: center;

        .back-btn {
          width: 1.1rem;
          height: 0.34rem;
          background-image: url('./img/back.png');
          background-size: 100% 100%;
          background-color: transparent;
          font-family: MicrosoftYaHei;
          font-size: 0.14rem;
          font-weight: bold;
          letter-spacing: 0.05rem;
          color: #fff;
          cursor: pointer;
          z-index: 20;

          span {
            margin-left: 0.12rem;
          }
        }

        .time {
          margin-left: 0.18rem;
          font-family: 'Arial-BoldMT';
          font-size: 0.36rem;
          color: #fff;
        }

        .time-display {
          margin-left: 0.13rem;
          display: flex;
          flex-direction: column;
          font-family: 'MicrosoftYaHei';
          font-size: 0.14rem;
          color: #dadada;

          .week {
            margin-bottom: 0.05rem;
          }
        }
      }
    }

    .nav-tabs {
      position: absolute;
      top: 1.12rem;
      left: 50%;
      transform: translateX(-50%);
      width: 3.21rem;
      height: 0.42rem;
      background-color: rgb(53, 109, 171);
      border-radius: 0.21rem;
      display: flex;
      align-items: center;
      z-index: 10;

      .tab {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        font-family: 'MicrosoftYaHei';
        font-size: 0.18rem;
        font-weight: bold;
        color: #fff;
        cursor: pointer;

        &.active {
          background-image: linear-gradient(
              0deg,
              rgba(9, 153, 172, 0.86) 0%,
              rgba(71, 132, 236, 0.86) 100%
            ),
            linear-gradient(#2ab6b1, #2ab6b1);
          background-blend-mode: normal, normal;
          border-radius: 21px;
        }
      }
    }

    .operation-btn {
      position: absolute;
      top: 1.2rem;
      left: 62%;
      transform: translateX(-50%);
      z-index: 20;
      width: 1rem;
      height: 0.3rem;
      background-color: #129bb1;
      border-radius: 0.21rem;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: 'MicrosoftYaHei';
      font-size: 0.16rem;
      color: #fff;
      cursor: pointer;
    }

    .canvas {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 1;

      .map-canvas {
        width: 100%;
        height: 100%;
      }
    }

    .points {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 15;

      .point {
        position: absolute;
        width: 0.61rem;
        height: 0.6rem;
        background: url('./img/alarm.png');
        background-size: 100% 100%;
        background-color: transparent;
      }

      .point-info {
        position: absolute;
        top: -0.29rem;
        left: 1.82rem;
        width: 2.65rem;
        min-height: 0.76rem;
        background: url('./img/alarmBgs.png');
        background-size: 100% 100%;
        background-color: transparent;
        padding: 0.35rem 0.14rem 0.1rem;

        &::before {
          content: ' ';
          position: absolute;
          top: 9%;
          left: -1.4rem;
          width: 1.38rem;
          height: 0.56rem;
          background: url('./img/line.png');
          background-size: 100% 100%;
          background-color: transparent;
        }

        .point-title {
          position: absolute;
          top: 0.06rem;
          left: 0.1rem;
          width: 1.33rem;
          height: 0.32rem;
          background: url('./img/title.png');
          background-size: 100% 100%;
          background-color: transparent;
        }

        .point-btn {
          position: absolute;
          top: 0.08rem;
          right: 0.68rem;
          width: 0.5rem;
          height: 0.2rem;
          background: rgb(42, 148, 202);
          border-radius: 0.04rem;
          font-family: MicrosoftYaHei;
          font-size: 0.12rem;
          color: #fff;
        }

        .back-btn {
          right: 0.1rem;
        }

        .point-content {
          width: 100%;
          min-height: 0.27rem;
          padding: 0.06rem 0.1rem;
          background-color: #c71c1c;
          font-family: MicrosoftYaHei;
          font-size: 0.12rem;
          color: #fff;
          text-shadow: 1px 0 0px rgba(0, 0, 0, 0.41);
        }
      }
    }

    .robot {
      position: absolute;
      width: 59px;
      height: auto;
      z-index: 5;
    }

    .yizhan {
      position: absolute;
      width: 32px;
      height: auto;
      z-index: 5;
    }

    .yizhan-name {
      position: absolute;
      z-index: 5;
      font-size: 12px;
      color: #f9fafb;
    }

    .icon {
      position: absolute;
      color: #fff;
      width: 50px;
      height: 50px;
      z-index: 10;
    }

    .context-menu {
      position: absolute;
      padding: 0.1rem;
      z-index: 10;

      li {
        width: 1.2rem;
        height: 0.35rem;
        background: rgb(53, 109, 171);
        font-family: MicrosoftYaHei;
        font-size: 0.13rem;
        line-height: 0.35rem;
        color: #fff;
        text-align: center;
        cursor: pointer;

        &:hover {
          background: rgb(18, 155, 177);
        }
      }
    }

    .right-panel {
      position: absolute;
      right: 0.3rem;
      top: 1.51rem;
      bottom: 0;
      width: 4.36rem;
      background: url('./img/rightBg.png');
      background-size: 100% 100%;
      background-color: transparent;
      padding-top: 0.2rem;
      z-index: 10;

      .panel-section {
        overflow: hidden;
      }

      .section-header {
        margin: 0 auto;
        width: 4.01rem;
        height: 0.71rem;
        background: url('./img/itemBg.png');
        background-size: 100% 100%;
        background-color: transparent;
        position: relative;

        span {
          position: absolute;
          top: 0.15rem;
          left: 0.68rem;
          font-family: MicrosoftYaHei;
          font-size: 0.18rem;
          color: #fff;
          text-shadow: 1px 0 0px rgba(17, 20, 22, 0.54);
        }
      }

      .video-container {
        width: 3.85rem;
        margin: 0 auto;

        .video-item {
          width: 100%;
          height: 20.88vh;
          background-color: rgba(0, 3, 7, 0.4);
        }

        .noVideo {
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 0.16rem;
          color: #fff;
        }
      }

      .video-info {
        width: 100%;
        height: 3.89vh;
        line-height: 3.89vh;
        padding-left: 0.16rem;
        background-color: #3d6996;
        border-radius: 0px 0px 0.04rem 0.04rem;
        font-family: MicrosoftYaHei;
        font-size: 0.14rem;
        color: #fff;
      }

      .port-list {
        width: 3.85rem;
        height: 25.38vh;
        margin: 0 auto;
        overflow-y: auto;
      }

      .port-item {
        width: 100%;
        padding: 0.06rem 0.16rem;
        border-radius: 0.04rem;
        background-color: #1e4f83;
        margin-bottom: 0.09rem;
        font-family: MicrosoftYaHei;
        font-size: 0.14rem;
        color: rgba(255, 255, 255, 0.6);
      }

      .active-port {
        background-color: #2f5986;
        border: 1px solid #10edc1;
        color: #17fff1;
      }
    }

    .footer {
      position: absolute;
      bottom: 0;
      left: 0.06rem;
      right: 0.06rem;
      width: 100%;
      height: 0.78rem;
      background: url('./img/bottom.png');
      background-size: 100% 100%;
      background-color: transparent;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/fireStation/index.vue